import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {createNamespace} from '../../common/utils';
import {getComponentName} from '../../common/utils/namespace';
import popup from '../popup';
import row from '../row';
import button from '../button';
import icon from '../icon';
import loading from '../loading';
var INTERNAL_THEN = '__INTERNAL_THEN__';

var _createNamespace = createNamespace('dialog'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export var DIALOG_ACTIONS;

(function(DIALOG_ACTIONS) {
    DIALOG_ACTIONS['CANCEL'] = 'cancel';
    DIALOG_ACTIONS['CONFIRM'] = 'confirm';
    DIALOG_ACTIONS['CLOSE'] = 'close';
})(DIALOG_ACTIONS || (DIALOG_ACTIONS = {}));

export default {
    name: getComponentName('Dialog'),
    model: {
        prop: 'show'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String
        },
        message: {
            type: String
        },
        width: {
            type: [String, Number],
            default: 622
        },
        cancelButton: {
            type: Boolean,
            default: false
        },
        closeButton: {
            type: Boolean,
            default: false
        },
        confirmButtonColor: {
            type: String,
            default: '#fa5671'
        },
        confirmButtonText: {
            type: String,
            default: '确认'
        },
        cancelButtonColor: {
            type: String,
            default: '#f5f5f7'
        },
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: undefined
        },
        beforeClose: {
            type: Function,
            default: function _default(action, resolve) {
                return resolve();
            }
        },
        container: {
            type: Function,
            default: function _default() {
                return document.body;
            }
        }
    },
    data: function data() {
        return {
            pendingConfirm: false
        };
    },
    computed: {
        style: function style() {
            return {
                width: ''.concat(this.width, 'px')
            };
        },
        allowOverlayClicking: function allowOverlayClicking() {
            return (this.closeOnClickOverlay === undefined && this.closeButton) || this.closeOnClickOverlay === true;
        }
    },
    render: function render() {
        var h = arguments[0];

        var _a, _b, _c, _d;

        var closeButton = this.closeButton,
            cancelButton = this.cancelButton,
            cancelButtonColor = this.cancelButtonColor,
            cancelButtonText = this.cancelButtonText,
            confirmButtonColor = this.confirmButtonColor,
            confirmButtonText = this.confirmButtonText,
            allowOverlayClicking = this.allowOverlayClicking,
            show = this.show,
            title = this.title,
            message = this.message,
            handleClose = this.handleClose,
            handleOverlayClick = this.handleOverlayClick,
            handleClosed = this.handleClosed,
            handleShowed = this.handleShowed,
            pendingConfirm = this.pendingConfirm;
        return h(
            popup,
            {
                class: b(),
                attrs: {
                    closeOnClickOverlay: allowOverlayClicking,
                    round: true,
                    show: show
                },
                on: {
                    closed: handleClosed,
                    'overlay-click': handleOverlayClick,
                    showed: handleShowed
                },
                ref: 'popup'
            },
            [
                title
                    ? h(
                          'h2',
                          {
                              class: b('title')
                          },
                          [this.title]
                      )
                    : this.$slots.title,
                message
                    ? h(
                          'p',
                          {
                              class: b('message')
                          },
                          [this.message]
                      )
                    : this.$slots.message || this.$slots.default,
                h(
                    row,
                    {
                        attrs: {
                            align: 'center'
                        },
                        class: b('ctrl')
                    },
                    [
                        cancelButton
                            ? ((_b = (_a = this.$scopedSlots) === null || _a === void 0 ? void 0 : _a.cancelButton) ===
                                  null || _b === void 0
                                  ? void 0
                                  : _b.call(_a, {
                                        click: this.handleCancel
                                    })) ||
                              h(
                                  'btn',
                                  {
                                      class: 'mai-flex-1',
                                      attrs: {
                                          color: cancelButtonColor,
                                          round: true,
                                          size: 'md',
                                          'text-color': '#333',
                                          type: 'weaken'
                                      },
                                      on: {
                                          click: this.handleCancel
                                      }
                                  },
                                  [cancelButtonText]
                              )
                            : null,
                        ((_d = (_c = this.$scopedSlots) === null || _c === void 0 ? void 0 : _c.confirmButton) ===
                            null || _d === void 0
                            ? void 0
                            : _d.call(_c, {
                                  click: this.handleConfirm
                              })) ||
                            h(
                                'btn',
                                {
                                    class: 'mai-flex-1',
                                    attrs: {
                                        color: confirmButtonColor,
                                        round: true,
                                        size: 'md',
                                        type: 'primary'
                                    },
                                    on: {
                                        click: this.handleConfirm
                                    }
                                },
                                [
                                    pendingConfirm
                                        ? h(loading, {
                                              attrs: {
                                                  color: '#fff',
                                                  size: '32'
                                              }
                                          })
                                        : confirmButtonText
                                ]
                            )
                    ]
                ),
                closeButton
                    ? h(
                          row,
                          {
                              attrs: {
                                  align: 'center',
                                  justify: 'center'
                              },
                              class: b('close'),
                              on: {
                                  click: handleClose
                              }
                          },
                          [
                              h(icon, {
                                  attrs: {
                                      name: 'close',
                                      size: '20'
                                  }
                              })
                          ]
                      )
                    : ''
            ]
        );
    },
    methods: {
        triggerClose: function triggerClose(action) {
            var _this = this;

            if (this.pendingConfirm) {
                return;
            }

            new Promise(function(resolve) {
                _this.$emit(action);

                if (action === DIALOG_ACTIONS.CONFIRM) {
                    _this.pendingConfirm = true;
                }

                if (_this.beforeClose) {
                    _this.beforeClose(action, resolve);
                } else {
                    _this.$emit('before-close-resolved', false);
                }
            })
                .then(function(abort) {
                    return abort instanceof Promise ? abort : Promise.resolve(abort);
                })
                .then(function(abort) {
                    _this.$emit('before-close-resolved', abort);

                    return !abort ? Promise.resolve() : Promise.reject(INTERNAL_THEN);
                })
                .then(function() {
                    _this.$emit('input', false);

                    _this.$emit('close');
                })
                .catch(function(e) {
                    if (e !== INTERNAL_THEN) {
                        throw e;
                    }
                })
                .finally(function() {
                    return (_this.pendingConfirm = false);
                });
        },
        handleClose: function handleClose() {
            this.triggerClose(DIALOG_ACTIONS.CLOSE);
        },
        handleCancel: function handleCancel() {
            this.triggerClose(DIALOG_ACTIONS.CANCEL);
        },
        handleConfirm: function handleConfirm() {
            this.triggerClose(DIALOG_ACTIONS.CONFIRM);
        },
        handleOverlayClick: function handleOverlayClick() {
            if (this.allowOverlayClicking) {
                this.triggerClose(DIALOG_ACTIONS.CLOSE);
            }
        },
        handleClosed: function handleClosed() {
            this.$emit('closed');
        },
        handleShowed: function handleShowed() {
            this.$emit('showed');
        }
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    },
    components: {
        popup: popup,
        row: row,
        icon: icon,
        btn: button,
        loading: loading
    }
};
